import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import apiRequest from '../../api/request';

const initialState = {
  lensSyncTable: {
    loading: false,
    data: [],
    meta: {},
  },
};

export const getLensSyncData = createAsyncThunk('lens/getLensSyncData', async (params) => {
  const searchParams = new URLSearchParams(params);
  const res = await apiRequest({
    method: 'get',
    url: `wise/get/all/data?${searchParams.toString()}`,
  });
  return res;
});

export const studentSync = createAsyncThunk('lens/studentSync', async (data) => {
  const res = await apiRequest({
    method: 'post',
    url: `wise/sync/student`,
    data: data,
  });
  return res;
});

export const courseSync = createAsyncThunk('lens/courseSync', async (data) => {
  const res = await apiRequest({
    method: 'post',
    url: `wise/sync/course`,
    data: data,
  });
  return res;
});

export const tutorSync = createAsyncThunk('lens/tutorSync', async (data) => {
  const res = await apiRequest({
    method: 'post',
    url: `wise/sync/tutor`,
    data: data,
  });
  return res;
});

export const userSync = createAsyncThunk('lens/userSync', async (data) => {
  const res = await apiRequest({
    method: 'post',
    url: `wise/sync/admin`,
    data: data,
  });
  return res;
});

export const sessionSync = createAsyncThunk('lens/sessionSync', async (data) => {
  const res = await apiRequest({
    method: 'post',
    url: `wise/sync/scheduled/session`,
    data: data,
  });
  return res;
});

export const getSessionSyncStatus = createAsyncThunk('lens/getSessionSyncStatus', async (params) => {
  const searchParams = new URLSearchParams(params);
  const res = await apiRequest({
    method: 'get',
    url: `wise/session/sync-status?${searchParams.toString()}`,
  });
  return res;
});

export const allUserSync = createAsyncThunk('lens/allUserSync', async (data) => {
  const res = await apiRequest({
    method: 'post',
    url: `wise/sync/one/by/one`,
    data: data,
  });
  return res;
});

const lens_sync_slice = createSlice({
  name: 'lens',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //==============get table data
    builder.addCase(getLensSyncData.pending, (state) => {
      state.lensSyncTable.loading = true;
    });

    builder.addCase(getLensSyncData.fulfilled, (state, action) => {
      state.lensSyncTable.loading = false;
      state.lensSyncTable.data = action.payload?.data;
      state.lensSyncTable.meta = action.payload?.meta;
    });

    // =============post student sync

    builder.addCase(studentSync.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(studentSync.fulfilled, (state) => {
      state.loading = false;
    });

    //=================post course sync

    builder.addCase(courseSync.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(courseSync.fulfilled, (state) => {
      state.loading = false;
    });

    //==============post tutor sync

    builder.addCase(tutorSync.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(tutorSync.fulfilled, (state) => {
      state.loading = false;
    });

    //===================post user sync

    builder.addCase(userSync.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(userSync.fulfilled, (state) => {
      state.loading = false;
    });
    //==================post all user sync
    builder.addCase(allUserSync.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(allUserSync.fulfilled, (state) => {
      state.loading = false;
    });
  },
});

export const lensSyncSlice = lens_sync_slice.reducer;
